import { Component } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-ticket-report-list',
  imports: [SharedModule],
  templateUrl: './ticket-report-list.component.html',
  styleUrl: './ticket-report-list.component.scss'
})
export class TicketReportListComponent {

  reports = [
    {
      name: 'Tickets by Status',
      description: 'Provides a breakdown of support tickets based on their current status such as Open, In Progress, Resolved, or Closed.',
      link: 'tickets/tickets-by-status'
    },
    {
      name: 'Tickets by Priority',
      description: 'Categorizes tickets based on urgency or importance — e.g., Low, Normal, High, or Urgent — to help prioritize resolution.',
      link: 'tickets/tickets-by-priority'
    },
    {
      name: 'Tickets by Source',
      description: 'Displays the origin of tickets such as Tina, WhatsApp, or Manual, enabling insight into support channels.',
      link: 'tickets/tickets-by-source'
    },
    {
      name: 'Tickets Assigned To',
      description: 'Lists tickets grouped by assigned support agent or team, helping in monitoring workloads and ownership.',
      link: 'tickets/tickets-assigned-to'
    }
  ];
}
